



































import Vue from "vue";
import { Header } from "@/components/MyTabs.vue";
import Overview from "./TaskInfo/Overview.vue";
import Overview2 from "./TaskInfo/Overview2.vue";
import Pods from "./TaskInfo/Pods.vue";
import { uuid } from "../../utils/uuid";

const Tabs: Header[] = [
  { label: "概览", name: "tab1", uuid: uuid() },
  { label: "Pods", name: "tab2", uuid: uuid() }
];

export default Vue.extend({
  name: "TaskInfo",
  components: { Overview, Pods, Overview2 },
  props: { kind: { type: String }, projectId: { type: String } },
  data() {
    return {
      Tabs: [] as Header[],
      dialog: false,
      tabActive: "tab1",
      taskData: null as any
      // statusEnum
    };
  },
  deactivated() {
    this.dialog = false;
    this.tabActive = "tab1";
  },
  methods: {
    show(data: any) {
      this.intiData(data);
      if (this.kind !== "SubTask") {
        this.Tabs = [Tabs[0]];
      } else {
        this.Tabs = [...Tabs];
      }
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      // 此项设置会触发 tabActive watch
      // 导致 面包屑 触发 setBeard
      // 目前是在面包屑上加 $nextTick
      this.tabActive = "tab1";
    },
    intiData(data: any) {
      let list = [];
      if (data.status.conditions) {
        list = data.status.conditions.map((e: any, index: any) => {
          e.index = index + 1;
          return e;
        });
      }
      let backoffLimit, completions, parallelism, activeDeadlineSeconds;
      if (this.kind === "Task" || this.kind === "SubTask") {
        ({
          backoffLimit,
          completions,
          parallelism,
          activeDeadlineSeconds
        } = data.spec);
      } else {
        ({
          backoffLimit,
          completions,
          parallelism,
          activeDeadlineSeconds
        } = data.spec.jobTemplate.spec);
      }
      this.taskData = Object.assign(
        {},
        {
          name: data.metadata.name,
          description: data.metadata.annotations?.description,
          list,
          backoffLimit,
          completions,
          parallelism,
          activeDeadlineSeconds
        }
      );
    },
    showTask(data: any) {
      this.$emit("showTask", data);
    }
  }
});
